import React, { useContext } from 'react'
import { MainContext } from '../../context/Main.context';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import { Tab } from '../Tab/Tab';
import { InputChoice, InputChoiceItem, InputChoiceLabel, InputChoiceWrapper, InputField, InputFieldLabel, InputFieldWrapper } from '../Tab/Tab.styled';
import { Ellispis } from './MorphoTab.styled';

export const MorphoTab = () => {
    const {
        currentFormTab,
        register,
        errors,
    } = useContext(MainContext);
    return (
        <Tab show={currentFormTab === 4}>
            <h2>Morphologie et Maillot :</h2>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="size">Taille :</InputFieldLabel>
                <InputField
                    type="number"
                    id="size"
                    name="size"
                    placeholder="Taille (en cm)"
                    {...register("size", {
                        required: {
                            value: true,
                            message: "Veuillez renseigner la taille du licencié"
                        },
                    })}
                />
                <ErrorMessage message={errors.size && errors.size.message} />
            </InputFieldWrapper>
            <InputFieldLabel>Latéralité :</InputFieldLabel>
            <InputChoiceWrapper>
                <InputChoiceItem>
                    <InputChoice
                        type="radio" 
                        id="right"
                        value="Droitier"
                        name="main-hand"
                        defaultChecked
                        {...register("main-hand")}
                    />
                    <InputChoiceLabel htmlFor="right">Droitier</InputChoiceLabel>
                </InputChoiceItem>
                <InputChoiceItem>
                    <InputChoice
                        type="radio"
                        id="left"
                        value="Gaucher"
                        name="main-hand"
                        {...register("main-hand")}
                    />
                    <InputChoiceLabel htmlFor="left">Gaucher</InputChoiceLabel>
                </InputChoiceItem>
                <InputChoiceItem>
                    <InputChoice
                        type="radio"
                        id="ambi"
                        value="Ambidextre"
                        name="main-hand"
                        {...register("main-hand")}
                    />
                    <InputChoiceLabel htmlFor="ambi">Ambidextre</InputChoiceLabel>
                </InputChoiceItem>
            </InputChoiceWrapper>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="size-jersey">Taille maillot</InputFieldLabel>
                <InputField
                    type="text"
                    id="size-jersey"
                    name="size-jersey"
                    placeholder="S, M, L..."
                    {...register("size-jersey", {
                        required: {
                            value: true,
                            message: "Veuillez renseigner la taille du maillot"
                        },
                    })}
                />
                <ErrorMessage message={errors["size-jersey"] && errors["size-jersey"].message} />
            </InputFieldWrapper>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="size-short">Taille short</InputFieldLabel>
                <InputField
                    type="text"
                    id="size-short"
                    name="size-short"
                    placeholder="S, M, L..."
                    {...register("size-short", {
                        required: {
                            value: true,
                            message: "Veuillez renseigner la taille du short"
                        },
                    })}
                />
                <ErrorMessage message={errors["size-short"] && errors["size-short"].message} />
            </InputFieldWrapper>
            <InputFieldWrapper>
                <InputFieldLabel htmlFor="jersey-number">Numero de maillot :</InputFieldLabel>
                <InputField
                    type="text"
                    id="jersey-number"
                    name="jersey-number"
                    placeholder="1, 99, 34, 7, 12"
                    {...register("jersey-number", {
                        required: {
                            value: true,
                            message: "Veuillez les numéros de maillot préférés du licencié"
                        },
                    })}
                />
                <Ellispis>
                    Choisissez jusqu'à 5 numéros, classés par ordre de préférence et séparés par des virgules
                </Ellispis>
                <ErrorMessage message={errors["jersey-number"] && errors["jersey-number"].message} />
            </InputFieldWrapper>
        </Tab>
    )
}
